import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Observable, first, map, startWith } from 'rxjs';

import { JsonConfiguration } from './configuration/json';
import { HeaderConfiguration } from 'src/app/shared/components/header/header.component';
import { Title } from 'src/app/shared/components/title/title.component';
import { ContratarService } from 'src/app/core/http/apiPricing/contratar.service';
import { GlobalDialogComponent } from 'src/app/shared/components/globaldialog/globaldialog.component';
import { SpinnerService } from 'src/app/core/services/spinner/spinner.service';
import { selectUser } from 'src/app/state/user/user.selectors';
import { ISuperGuaranteeBody } from 'src/app/core/interfaces/request/ISuperGuarantee.interface';
import { ProductosRequisitoService } from 'src/app/core/http/apiProducto/productos-requisito.service';

export interface ISerialNumbersResponse {
  serialNumber: string;
  objeto: string;
  valor: number;
}

@Component({
  selector: 'app-super-guarantee',
  templateUrl: './super-guarantee.component.html',
  styleUrls: ['./super-guarantee.component.scss'],
  providers: [JsonConfiguration],
})
export class SuperGuaranteeComponent {
  titleData: Title = this.jsonConfiguration.titleData;
  headerConfiguration: HeaderConfiguration =
    this.jsonConfiguration.headerConfiguration;

  guaranteeForm: FormGroup = this.formBuilder.group({
    serialNumber: [, Validators.required],
    phone: ['', [Validators.required, Validators.pattern(/^\d{9}$/)]],
  });

  serialNumbersArr: ISerialNumbersResponse[] = [];

  filteredOptions: Observable<ISerialNumbersResponse[]>;

  OID!: string

  constructor(
    private jsonConfiguration : JsonConfiguration,
    private productoRequisito : ProductosRequisitoService,
    private contratarService  : ContratarService,
    private spinnerService: SpinnerService,
    private formBuilder   : FormBuilder,
    private dialog: MatDialog,
    private store : Store,
  ) {
    this.getPersonFromStorage()
  }
  
  getPersonFromStorage() {
    this.store
    .select(selectUser)
    .pipe(first())
    .subscribe((res) => {
      this.OID = res.idTokenClaims.oid
      this.getSerialNumbersData(this.OID);
    })
  }

  getSerialNumbersData(OID: string) {
    this.serialNumbersArr = [];
    this.productoRequisito.getBerriaSerialNumbers(OID).subscribe({
      next: (serialNumbersResponse) => {

        if(serialNumbersResponse.data){
          serialNumbersResponse.data.forEach((element) =>
          this.serialNumbersArr.push(...element.objetos)
          );
        }

        this.listenChanges();
      },
      error: (err) => console.log('Error: ', err),
    });
  }

  listenChanges() {
    this.filteredOptions = this.guaranteeForm.controls['serialNumber']
      .valueChanges
      .pipe(
        startWith(''),
        map((value) => this._filter(value))
      );
  }

  private _filter(value: any): ISerialNumbersResponse[] {
    // Filtra los nº de serie conforme va escribiendo el usuario.
    const filterValue = value ? value.toString().toLowerCase() : '';
    return this.serialNumbersArr.filter((option) =>
      option.serialNumber.toLowerCase().includes(filterValue)
    );
  }

  fieldIsValid(form: FormGroup, field: string) {
    return form.controls[field].errors && form.controls[field].touched;
  }

  activateAndFinish() {
    if (this.guaranteeForm.invalid) return;

    this.spinnerService.show();

    const bodyRequest = this.generateBodyRequest();
    this.contractSuperGuarantee(bodyRequest);
  }

  generateBodyRequest() {
    const { serialNumber, phone } = this.guaranteeForm.value;

    const bodyRequest: ISuperGuaranteeBody = {
      Entidad: 'BER0009',
      Phonenumber: phone,
      Serialnumber: serialNumber,
    };

    return bodyRequest;
  }

  contractSuperGuarantee(bodyRequest: ISuperGuaranteeBody) {
    this.contratarService.contractSuperguarantee(bodyRequest).subscribe({
      next: (res) => {
        this.spinnerService.hide();
        res !== null && res.succeeded
          ? this.finishDialog(true)
          : this.finishDialog(false);

        this.getSerialNumbersData(this.OID);
        this.guaranteeForm.reset();
      },
      error: () => {
        this.spinnerService.hide();
        this.finishDialog(false);
        console.log('Error en la llamada de contratación de super garantía');
      },
    });
  }

  finishDialog(succeeded: boolean) {
    let configDialog;

    succeeded
      ? (configDialog = this.jsonConfiguration.confirmDialogConfig)
      : (configDialog = this.jsonConfiguration.errorDialogConfig);

    this.dialog.closeAll();
    const dialogRef = this.dialog.open(GlobalDialogComponent, {
      disableClose: true,
      panelClass: 'finishDialog-panel',
      data: {
        icon: configDialog.icon,
        title: configDialog.title,
        subtitle: configDialog.subtitle,
        button: {
          type: 'close',
          text: configDialog.buttonText,
        },
        closeIcon: false,
      },
    });
  }
}
